import {disclaimerObject} from "../disclaimerObject";

export class disclaimerObject_nl_BE extends disclaimerObject{
    // eslint-disable-next-line
    constructor() {
        super();
    }

    getDisclaimer = (params) => {
        const {
            financialProduct
        } = params;


        return financialProduct?.disclaimer_nl_BE;
    }

}

export default disclaimerObject_nl_BE;